module.exports = "<div>\n  <list-workwave-template-online-store></list-workwave-template-online-store>\n</div>\n"